import React, { useEffect, useRef, useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import axiosInstance from "../axiosConfig";
import Select from "react-select";
import Swal from "sweetalert2";
import loaderGif from "../assets/Img/loading1.gif";
import "../assets/CSS/Dashboard.css";

export default function SheetQuentyLeather() {
  const API_BASE_URL = axiosInstance.defaults.baseURLPath;

  const [isSidebarVisible, setIsSidebarVisible] = useState(true);

  // upload
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  // listing
  const [data, setData] = useState([]);
  const [sheetNames, setSheetNames] = useState([]);
  const [sheetFilter, setSheetFilter] = useState("");
  const [lotFilter, setLotFilter] = useState("");
  const [pdfError, setPdfError] = useState("");

  const [allData, setAllData] = useState([]);

  // pdf filter
  const [pdfNames, setPdfNames] = useState([]);
  const [pdfFilter, setPdfFilter] = useState("");

  const [listLoading, setListLoading] = useState(false);

  const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);

  const user = JSON.parse(localStorage.getItem("user")) || {};
  const loggedInUser = user.Name || "Unknown";
  const loggedInUserId = user.EmployeeID;
  const user_type = user.Auth;

  const sheetOptions = sheetNames.map(s => ({
    value: s,
    label: s
  }));

  const pdfOptions = pdfNames.map(p => ({
    value: p,
    label: p
  }));

  /* ================= FETCH LIST ================= */

  const fetchList = async (sheet = "", lot = "", pdf = "") => {
    try {
      setListLoading(true);

      let url = "/api/sheet-quenty-leather?upload_type=pdf&";

      if (pdf) url += `pdf_name=${encodeURIComponent(pdf)}&`;
      if (sheet) url += `sheet_name=${encodeURIComponent(sheet)}&`;
      if (lot) url += `lot_id=${encodeURIComponent(lot)}`;

      const res = await axiosInstance.get(url);
      setData(res.data || []);
    } catch (err) {
      console.error("List load failed", err);
    } finally {
      setListLoading(false);
    }
  };

  useEffect(() => {
    loadMasterData();
    fetchList();
  }, []);

  const loadMasterData = async () => {
    try {
      const res = await axiosInstance.get("/api/sheet-quenty-leather");
      const list = res.data || [];

      setAllData(list);

      // unique pdf names
      const pdfs = [...new Set(list.map(r => r.pdf_name))];
      setPdfNames(pdfs);

      // unique sheets (initial)
      const sheets = [...new Set(list.map(r => r.sheet_name))];
      setSheetNames(sheets);

    } catch (err) {
      console.error("Master data load failed", err);
    }
  };

  /* ================= UPLOAD ================= */
  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) {
      setSelectedFile(null);
      return;
    }

    if (pdfNames.includes(file.name)) {
      setPdfError("This PDF is already uploaded");
      showAlert("This PDF is already uploaded", "danger");
      e.target.value = "";
      setSelectedFile(null);
      return;
    }

    setPdfError("");

    // Allow only PDF
    if (
      file.type !== "application/pdf" &&
      !file.name.toLowerCase().endsWith(".pdf")
    ) {
      showAlert("Only PDF files are allowed", "error");
      e.target.value = "";       // reset input
      setSelectedFile(null);
      return;
    }

    setSelectedFile(file);
  };

  const handleUpload = async () => {
    if (!selectedFile) return;

    setPdfError("");
    setUploading(true);

    setUploading(true);
    const fd = new FormData();
    fd.append("pdfFile", selectedFile);
    fd.append("created_by", loggedInUserId);

    try {
      const res = await axiosInstance.post("/api/pdf-process", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      showAlert(res.data.message, "success");
      setSelectedFile(null);
      fileInputRef.current.value = "";
      fetchList(sheetFilter, lotFilter);
      loadMasterData();
    } catch (err) {
      console.error(err);
      //showAlert("PDF upload failed", "error");
      const backendMsg =
        err?.response?.data?.error ||        // <-- duplicate PDF msg
        err?.response?.data?.details ||      // <-- parsing error msg
        "PDF upload failed";

      setPdfError(backendMsg);

      showAlert(backendMsg, "danger");
    } finally {
      setUploading(false);
    }
  };

  /* ================= ALERT ================= */
  const showAlert = (msg, type) => {
    const ph = document.getElementById("alertPlaceholder");
    ph.innerHTML = `
      <div class="alert alert-${type} alert-dismissible fade show">
        <strong>${type === "success" ? "Success!" : "Error!"}</strong> ${msg}
        <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
      </div>
    `;
    setTimeout(() => (ph.innerHTML = ""), 3000);
  };

  const handleDeleteSheet = async (sheetId) => {
    const result = await Swal.fire({
      title: "Delete this sheet?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      focusCancel: true,
    });

    if (!result.isConfirmed) return;

    try {
      await axiosInstance.delete(`/api/sheet-quenty-leather/${sheetId}`);

      await Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "Sheet deleted successfully.",
        timer: 1500,
        showConfirmButton: false,
      });

      fetchList(sheetFilter, lotFilter, pdfFilter);
      loadMasterData();

    } catch (err) {
      console.error(err);

      Swal.fire({
        icon: "error",
        title: "Delete failed",
        text: err?.response?.data?.error || "Something went wrong.",
      });
    }
  };

  return (
    <div className="d-flex dashboard">

      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>

      <div className="flex-grow-1">
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />

        <main className="main-container p-4">
          <div id="alertPlaceholder" />

          <h3 className="mb-4">Sheet Quantity – Leather</h3>

          {/* ================= UPLOAD ================= */}
          {(user_type === 'Admin' || ["1021","1022","90","3014","260"].includes(user?.EmployeeID)) && (
          <div className="card p-3 mb-4">
            <label className="form-label fw-bold">Upload PDF</label>
            <input
              type="file"
              accept=".pdf"
              className="form-control"
              ref={fileInputRef}
              onChange={handleFileChange}
            />
            <button
              className="btn btn-primary mt-2"
              disabled={!selectedFile || uploading}
              onClick={handleUpload}
            >
              Upload PDF
            </button>
          </div>
          )}

          {!uploading && pdfError && (
            <div
              className="card border-danger d-flex justify-content-center align-items-center mb-4"
              style={{ minHeight: "300px" }}
            >
              <div className="text-center">
                <div className="fw-bold text-danger mb-2">
                  {pdfError === "This PDF is already uploaded"
                  ? "Duplicate PDF"
                  : "PDF Format Not Supported"}
                </div>

                <div className="text-muted mb-3">
                  {pdfError}
                </div>

                {pdfError !== "This PDF is already uploaded" && (
                  <ul className="text-start small text-muted">
                    <li>PDF layout may be different from the expected format</li>
                    <li>Sheet names or structure may be missing</li>
                    <li>Scanned / image-based PDFs are not supported</li>
                  </ul>
                )}

              </div>
            </div>
          )}

          {/* ================= FILTER ================= */}
          <div className="d-flex align-items-center gap-3 mb-4">

            {/* PDF Dropdown */}
            <Select
              className="w-25"
              options={pdfOptions}
              isClearable
              placeholder="Search PDF..."
              value={pdfOptions.find(o => o.value === pdfFilter) || null}
              onChange={(selected) => {
                const value = selected ? selected.value : "";
                setPdfFilter(value);
                setSheetFilter(""); // reset sheet
                fetchList("", lotFilter, value);

                // update sheet dropdown based on pdf
                const filteredSheets = allData
                  .filter(r => r.pdf_name === value)
                  .map(r => r.sheet_name);

                setSheetNames([...new Set(filteredSheets)]);
              }}
            />

            {/* Sheet Dropdown */}
            <Select
              className="w-25"
              options={sheetOptions}
              isClearable
              placeholder="Search Sheet..."
              value={sheetOptions.find(o => o.value === sheetFilter) || null}
              onChange={(selected) => {
                const value = selected ? selected.value : "";
                setSheetFilter(value);
                fetchList(value, lotFilter);
              }}
            />

            {/* Lot Filter */}
            <input
              type="text"
              placeholder="Filter by Lot ID"
              className="form-control w-25"
              value={lotFilter}
              onChange={(e) => {
                setLotFilter(e.target.value);
                fetchList(sheetFilter, e.target.value);
              }}
            />

            {/* Clear Filters */}
            {(sheetFilter || lotFilter) && (
              <button
                className="btn btn-outline-secondary"
                onClick={() => {
                  setSheetFilter("");
                  setLotFilter("");
                  fetchList("", "");
                }}
              >
                Clear
              </button>
            )}

            {/* Total Count */}
            <div className="ms-auto text-muted fw-semibold">
              Total: {data.length}
            </div>

          </div>


          {/* ================= LIST LOADER ================= */}
          {listLoading && (
            <div className="card d-flex justify-content-center align-items-center" style={{ minHeight: 300 }}>
              <img src={loaderGif} alt="loading" width={120} />
              <div className="mt-2 fw-semibold text-muted">Loading data...</div>
            </div>
          )}

          {/* ================= LIST ================= */}

          {uploading && (
            <div
              className="card d-flex justify-content-center align-items-center"
              style={{ minHeight: "500px" }}
            >
              <div className="w-75 text-center">
                <img
                  src={loaderGif}
                  alt="processing"
                  style={{ width: 350, height: 350 }}
                />

                <div className="mt-3 fw-semibold">
                  Processing PDF…
                </div>

                <div className="progress mt-3" style={{ height: "8px" }}>
                  <div
                    className="progress-bar progress-bar-striped progress-bar-animated"
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
            </div>
          )}

          {!listLoading && !uploading && !pdfError && data.length === 0 && (
            <div
              className="card d-flex justify-content-center align-items-center"
              style={{ minHeight: "300px" }}
            >
              <div className="text-muted fw-semibold">
                No data found
              </div>
            </div>
          )}

          {!listLoading && !uploading && data.map((sheet) => (
            <div key={sheet.sheet_id} className="card mb-4">
              <div className="card-header">
                <div className="row align-items-start">
                  
                  {/* LEFT: Sheet + Lot */}
                  <div className="col-md-4">
                    <div className="fw-bold text-dark">
                      Sheet: {sheet.sheet_name}
                    </div>

                    {Number(sheet.nesting_surface_cm2) > 0 && (
                      <>
                        <div className="fw-bold text-dark">
                          Standard Nesting Surface Area : {" "}
                          {((Number(sheet.nesting_surface_cm2) / 100)).toFixed(2)} dm²
                        </div>

                        <div className="text-muted small">
                          (Calculated from nesting surface in square centimeters)
                        </div>
                      </>
                    )}

                    <div className="text-muted small">
                      Lot: {sheet.lot_id}
                    </div>
                  </div>

                  {/* RIGHT: Image */}
                  {sheet.image && (
                    <div className="col-md-4 d-flex justify-content-center text-right">
                      <div className="border1 rounded p-2 mb-2">
                        <img
                          src={`${API_BASE_URL}/${sheet.image}`}
                          alt={sheet.sheet_name}
                          className="img-fluid d-block mx-auto"
                        />
                      </div>
                    </div>
                  )}

                  <div className="col-md-4 text-end">
                    {user_type === "Admin" && (
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDeleteSheet(sheet.sheet_id)}
                      >
                        Delete Sheet
                      </button>
                    )}
                  </div>


                </div>
              </div>

              <div className="card-body p-0">
                <table className="table table-bordered mb-0">
                  <thead className="table-dark">
                    <tr>
                      <th>Part Name</th>
                      <th>Size</th>
                      <th>Qty</th>
                      <th>Inch</th>
                      <th>Color</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sheet.meta.map((m) => (
                      <tr key={m.meta_id}>
                        <td>{m.part_name}</td>
                        <td>{m.size}</td>
                        <td>{m.quantity}</td>
                        <td>{m.inch ?? "-"}</td>
                        <td>
                          <span
                            style={{
                              background: m.color,
                              display: "inline-block",
                              width: 22,
                              height: 22,
                              borderRadius: "50%",
                              border: "1px solid #ccc"
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </main>
      </div>
    </div>
  );
}
